<script lang="ts">
	import { Card } from '@infinitro/card';
	import type { GameInfo } from '@infinitro/catalog-min';

	export let item: GameInfo;
	export let id: string | undefined = undefined;
</script>

<Card {item} width="85px" eagerLoad={true} />
